import type { ExtendedScrapingErrorResponseErrorTypeEnum } from "libs/codegen/property-onboarding";
import { memo, useEffect, useState } from "react";
import { DuplicatedModal } from "./notifications/DuplicatedModal.tsx";
import { IncorrectUrlNotification } from "./notifications/IncorrectUrlNotification.tsx";
import { NotFoundModal } from "./notifications/NotFoundModal.tsx";
import { UnexpectedErrorToast } from "./notifications/UnexpectedErrorToast.tsx";
import { UnsupportedUrlNotification } from "./notifications/UnsupportedUrlNotification.tsx";
import { scrapingErrorResponseMapper } from "./scrapingErrorResponseMapper.ts";

interface Props {
    errorType: ExtendedScrapingErrorResponseErrorTypeEnum;
    onLearnMore: () => void;
}

export const ValidationErrorNotification = memo<Props>(({ errorType, onLearnMore }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const handleCloseModal = () => {
        setModalOpen(false);
    };

    useEffect(() => {
        if (
            [
                scrapingErrorResponseMapper.BcomPropertyNotFound,
                scrapingErrorResponseMapper.AirbnbPropertyNotFound,
                scrapingErrorResponseMapper.Duplicated,
            ].includes(errorType)
        ) {
            setModalOpen(true);
        }
    }, [errorType]);

    switch (errorType) {
        case scrapingErrorResponseMapper.UnexpectedError:
            return <UnexpectedErrorToast />;
        case scrapingErrorResponseMapper.UnsupportedUrl:
            return <UnsupportedUrlNotification />;
        case scrapingErrorResponseMapper.IncorrectAirbnbUrl:
        case scrapingErrorResponseMapper.IncorrectBcomUrl:
            return <IncorrectUrlNotification {...{ errorType, onLearnMore }} />;
        case scrapingErrorResponseMapper.AirbnbPropertyNotFound:
        case scrapingErrorResponseMapper.BcomPropertyNotFound:
            return <NotFoundModal {...{ errorType, open: modalOpen, onClose: handleCloseModal }} />;
        case scrapingErrorResponseMapper.Duplicated:
            return <DuplicatedModal {...{ open: modalOpen, onClose: handleCloseModal }} />;
        default:
            return null;
    }
});
